import React from 'react';

export const erroMessageView = ( props ) => {

    const { data, className,close } = props;
    return(
            (className == 'fail') ? 
                <div  className={ `error error--${className}` }> <span>{data}</span>
                <i className="fa fa-close" onClick= { () => {
                   close()
                }} />
            </div> :
            <div  className={ `error error--${className}` }> {data} </div>
       
    );

};

erroMessageView.defaultProps = {
    data: '',
    className: ''
};